import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { redirectToLegalConsentPage } from '@/src/globalFunction';
import { RootState } from '@/src/reducers/types';

const LEGAL_DOCUMENT_PUBLISHED_SOCKET_CHANNEL_ID = 'NEW_LEGAL_DOCUMENT_PUBLISHED';
const MISSING_CONSENTS_SOCKET_CHANNEL_ID = 'MISSING_REQUIRED_CONSENTS';

const useAppSocketSubscriptions = () => {
  const socket = useSelector((store: RootState) => store.socket.container);

  useEffect(() => {
    if (!socket) {
      return;
    }

    socket.on(LEGAL_DOCUMENT_PUBLISHED_SOCKET_CHANNEL_ID, () => redirectToLegalConsentPage());

    socket.on(MISSING_CONSENTS_SOCKET_CHANNEL_ID, () => redirectToLegalConsentPage());

    return () => {
      socket.off(LEGAL_DOCUMENT_PUBLISHED_SOCKET_CHANNEL_ID);
      socket.off(MISSING_CONSENTS_SOCKET_CHANNEL_ID);
    };
  }, [socket]);
};

export default useAppSocketSubscriptions;
